module.exports = __webpack_public_path__ + "cb7b55f13c109a480698ac14b826e388.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/festival05.jpg
// module id = 514
// module chunks = 0